import OrderReportPage from './OrderReportPage';

export default OrderReportPage;
